export default __webpack_public_path__ + "static/media/036-onion.72f1b067.svg";